const shortcutModuleOrder: readonly string[] = ["material", "availability", "engage", "verify", "events", "count"];

export default shortcutModuleOrder;
